export default {
    ReceiptIsNotPayment: 0,
    ReceiptIsPayment: 1,
  };
  